// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".QuestionStyles-cls1___dc9eaa53cd4aae4696b{/*!*/}.QuestionStyles-cls2__cb4a7324564ce94c2710{font-family:\"Roboto\";font-weight:400;font-size:14px;display:flex;color:#000;text-align:left}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "QuestionStyles-cls1___dc9eaa53cd4aae4696b",
	"cls2": "QuestionStyles-cls2__cb4a7324564ce94c2710 QuestionStyles-cls1___dc9eaa53cd4aae4696b"
};
export default ___CSS_LOADER_EXPORT___;
